export class LiveCallModel {
  id: number;
  from: string;
  fromName: string;
  fromNumber: string;
  to: string;
  toName: string;
  toNumber: string;
  account: string;
  start: string;
  domain: string;
  rec: string;
  cmc: string;
  priority: string;
  trunk: any[];
  extension: string[];
  callstate: string;
  state: string;

  constructor(data: any) {
    this.id = data.id;
    this.from = data.from;
    this.fromName = data['from-name'];
    this.fromNumber = data['from-number'];
    this.to = data.to;
    this.toName = data['to-name'];
    this.toNumber = data['to-number'];
    this.account = data.account;
    this.start = data.start;
    this.domain = data.domain;
    this.rec = data.rec;
    this.cmc = data.cmc;
    this.priority = data.priority;
    this.trunk = data.trunk;
    this.extension = data.extension;
    this.callstate = data.callstate;
    this.state = data.state;
  }
}
